var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-shadow-bottom bgc-white bdrs10 p20 mt25"},[_c('div',{staticClass:"u-markDown",domProps:{"innerHTML":_vm._s(_vm.propContentHtml)}})])}
var staticRenderFns = []

export { render, staticRenderFns }